import { actionGenerator } from '../../utils/store/actionGenerator';
import { ITypedReduxAction } from '../../types/redux';

export enum EFullscreenGalleryActionTypes {
  CloseGallery = 'fullscreenGallery/closeGallery',
  OpenGallery = 'fullscreenGallery/openGallery',
}

export type TCloseFullscreenGallery = ITypedReduxAction<EFullscreenGalleryActionTypes.CloseGallery>;
export type TCloseFullscreenGalleryAction = () => TCloseFullscreenGallery;

export const closeFullscreenGallery: TCloseFullscreenGalleryAction =
  actionGenerator<EFullscreenGalleryActionTypes.CloseGallery>(EFullscreenGalleryActionTypes.CloseGallery);

export interface IOpenFullscreenGalleryPayload {
  slideIndex: number;
  dateSlideIndex: number;
}

export type TOpenFullscreenGallery = ITypedReduxAction<
  EFullscreenGalleryActionTypes.OpenGallery,
  IOpenFullscreenGalleryPayload
>;
export type TOpenFullscreenGalleryAction = (payload: IOpenFullscreenGalleryPayload) => TOpenFullscreenGallery;

export const openFullscreenGallery: TOpenFullscreenGalleryAction = actionGenerator<
  EFullscreenGalleryActionTypes.OpenGallery,
  IOpenFullscreenGalleryPayload
>(EFullscreenGalleryActionTypes.OpenGallery);

export type TFullscreenGalleryActions = TCloseFullscreenGallery | TOpenFullscreenGallery;
